<template>
    <footer class="store-footer p-sm-4 text-light bg-site">
        <div class="container pt-4">
            <div class="row gy-4 gx-5">
                <div class="col-lg-6 col-md-6 align-self-center justify-content-center">
                    <a href="/" class="logo"><img :src="G.systemData?.footer_logo?.value" :alt="G.projectName" style="width: 100px;" class="w-751 w-sm-501 border-secondary1 rounded mb-2" /></a>
                    <!-- <img src="/assets/images/logo-tw.png" :alt="G.projectName" class="w-75 w-sm-50" /> -->
                    <!-- <h5 class="h3">{{G.projectName}}</h5> -->
                    <!-- <p class="small">{{G.systemData?.slogan?.value}}</p> -->
                    <p class="fs-6">{{TR.slogan_text}}</p>
                </div>
                <div class="col-lg-6 col-md-6 align-self-center justify-content-center">
                    <div class="row">
                        <div class="col-12 col-md-6">
                            <h5 class="mb-3">{{ TR.menu }}</h5>
                            <ul class="list-unstyled">
                                <li v-for="(item, index) in data" :key="index">
                                    <a :href="item.link">{{ item.translate.name }}</a>
                                </li>
                            </ul>
                        </div>
                        <div class="col-12 col-md-6">
                            <h5 class="mb-3">{{ TR.advanced }}</h5>
                            <ul class="list-unstyled">
                                <!-- <li><a href="#">Supports</a></li> -->
                                <li><a href="#">Faqs</a></li>
                                <li><a href="#">Privacy Policy</a></li>
                                <!-- <li><a href="#">News and blogs</a></li>
                                <li><a href="#">News Terms & condition</a></li> -->
                            </ul>
                        </div>
                    </div>
                </div>
                <!-- <div class="col-lg-4 col-md-6 align-self-center justify-content-center"> -->
                    <!-- <h5 class="mb-3">Xəbər bülleteni</h5>
                    <p class="small">Xəbər bülleteninə qoşulmaqla Siz daima yeniliklərdən xəbərdar olacaqsınız.</p>
                    <form action="#">
                        <div class="input-group mb-3">
                            <input class="form-control" type="text" placeholder="Sizin email ünvanınız" aria-label="..." aria-describedby="button-addon2">
                            <button class="btn btn-primary" id="button-addon2" type="button"><i class="fas fa-paper-plane"></i></button>
                        </div>
                    </form> -->

                    <!-- <div class="social-links row row-cols-4">
                        <a href="#"><i class="fab fa-google"></i></a>
                        <a href="#"><i class="fab fa-youtube"></i></a>
                        <a href="#"><i class="fab fa-twitter"></i></a>
                        <a href="#"><i class="fab fa-instagram"></i></a>
                        <a href="#"><i class="fab fa-facebook"></i></a>
                        <a href="#"><i class="fab fa-whatsapp"></i></a>
                    </div> -->
                <!-- </div> -->
            </div>


            <div class="row row-cols-1 row-cols-sm-2 mt-4 pt-3 border-1 border-top small">
                <div class="col">
                    <p v-html="G.footerPowered"></p>
                </div>
                <div class="col d-flex">
                    <ul class="list-unstyled d-flex ms-auto">
                        <li class="ms-3"><a class="" href="#"><i class="fab fa-google"></i></a></li>
                        <li class="ms-3"><a class="" href="#"><i class="fab fa-youtube"></i></a></li>
                        <li class="ms-3"><a class="" href="#"><i class="fab fa-twitter"></i></a></li>
                        <li class="ms-3"><a class="" href="#"><i class="fab fa-instagram"></i></a></li>
                        <li class="ms-3"><a class="" href="#"><i class="fab fa-facebook-f"></i></a></li>
                        <li class="ms-3"><a class="" href="#"><i class="fab fa-whatsapp"></i></a></li>
                    </ul>
                </div>
            </div>

        </div>
    </footer>
</template>


<script>
import { G } from '@/_common';

export default {
    name: 'FooterBlackC',
    props:{
        data:{
            type: Array,
            default: () => []
        },
        TR:{
            type: Object,
            default: () => {}
        },
    },
    setup() {
        return { G };
    },
}
</script>


<style lang="scss">
.store-footer {
    a{
        color: #c9c9c9;
    }
    a:hover{
        color: rgb(128, 128, 128);
    }
    .social-links > a{
        display: flex;
        // padding: 8px;
        margin: 10px;
        width: 40px;
        height: 40px;
        background-color: #443f3f;
        border-radius: 50%;
        // font-size: 18pt;
        font-size: calc(var(--bs-body-font-size) * 1.3);
        justify-content: center;
        align-items: center;
        // color: black;
    }
    .social-links > a:hover{
        background-color: #b3b3b3;
    }
}
</style>
